<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-list-item-title class="secondary--text font-weight-bold">{{ offer.company.name }}</v-list-item-title>
				<v-list-item-subtitle class="black--text subtitle-2 font-weight-bold"
					>{{ dateFormattedMomentjs(offer.date) }} - {{ dateFormattedMomentjs(offer.end_date) }}</v-list-item-subtitle
				>

				<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
				<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>

				<v-list-item-subtitle class="primary--text lighten-1 font-weight-bold">#{{ offer.offer_code }}</v-list-item-subtitle>
				<v-list-item-subtitle v-if="!locumIsApproved" class="red--text lighten-1 font-weight-bold">
					Not available to you yet
					<v-icon medium color="red" @click="showLocumUnapprovedBanner()">help</v-icon>
				</v-list-item-subtitle>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="locumViewOffer(offer)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'LocumOffersNearMeCard',
	components: {},
	props: {
		offer: { type: Object, required: true },
	},

	data: () => ({
		showTimes: true,
		start_time: '',
		end_time: '',
	}),

	computed: {
		locumIsApproved() {
			return store.getters.user.approved;
		},
	},

	mounted() {
		this.getTimes();
	},

	methods: {
		locumViewOffer(offer) {
			bus.$emit('view-offer-near-me', offer);
		},

		showLocumUnapprovedBanner() {
			window.scrollTo(0, 0);
			bus.$emit('locum-not-approved', 'You cannot apply to Practice Offers until your profile has been approved ');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.offer.start_time;
			this.end_time = this.offer.end_time;
			for (let index = 0; index < this.offer.request_dates.length; index++) {
				if (
					moment(this.offer.request_dates[index].start_time).format('HH:mm') !== this.offer.start_time ||
					moment(this.offer.request_dates[index].end_time).format('HH:mm') !== this.offer.start_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},
	},
};
</script>
